import {
  cloudConfigLabel,
  cloudKeyLabel,
  formatDisplayDate,
  lastCloudCallLabel,
  providerLabel,
  typeLabel,
} from '../../materiels/materielDisplayMaps';

function Row({ label, value }) {
  return (
    <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-3 py-2 border-b border-gray-50 last:border-0">
      <dt className="text-xs text-gray-500 sm:w-40 shrink-0">{label}</dt>
      <dd className="text-sm text-gray-900 min-w-0 break-words">{value || '—'}</dd>
    </div>
  );
}

/**
 * Onglet Informations — affichage métier, jamais cloudSn / enums bruts.
 */
export default function MaterielDrawerInfoTab({ item, loading }) {
  if (loading) {
    return (
      <div className="space-y-3 p-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="h-8 rounded bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  if (!item) {
    return (
      <p className="text-sm text-gray-500">
        Impossible d&apos;afficher les informations.
      </p>
    );
  }

  const model = item.model && String(item.model).trim() ? item.model : '—';
  const label = item.label && String(item.label).trim() ? item.label : '—';
  const sn = item.serialNumber ? String(item.serialNumber) : '—';
  const probable = item.health?.probableCause
    ? String(item.health.probableCause).trim()
    : null;

  return (
    <dl className="space-y-0">
      <Row label="Type" value={typeLabel(item.type)} />
      <Row label="Libellé" value={label} />
      <Row label="Modèle" value={model} />
      <Row label="Numéro de série" value={sn} />
      <Row label="Fournisseur" value={providerLabel(item.provider)} />
      <Row label="Date d’ajout" value={formatDisplayDate(item.createdAt)} />
      <Row
        label="Dernière modification"
        value={formatDisplayDate(item.updatedAt)}
      />
      <Row
        label="Configuration cloud"
        value={cloudConfigLabel(item.configComplete)}
      />
      <Row label="Clé cloud" value={cloudKeyLabel(item.hasCloudAppKey)} />
      <Row label="Dernier appel cloud" value={lastCloudCallLabel(item)} />
      {probable ? (
        <Row label="Cause probable" value={probable} />
      ) : null}
    </dl>
  );
}
